module.exports = __webpack_public_path__ + "static/media/FK.fb76ac2c.svg";